export const OSB_AEM_VEHICLE_STEP_PROPERTY_KEYS = {
    VEHICLE_STEP: 'vehicle-step',
    OSB_TITLE_LABEL: 'onlineBookingServiceTitleLabel',
    FORD_ACCOUNT_LABEL: 'fordAccountLabel',
    FORD_ACCOUNT_DESC: 'fordAccountDesc',
    LOGIN_OR_REGISTRATION_CTA: 'loginOrRegisterButtonLabel',
    LOGIN_OR_REG_DESC: 'loginOrRegiserDescription',
    OR_LABEL: 'orLabel',
    COTINUE_CTA: 'continueButtonLabel',
    I_DONT_KNOW_DETAILS_LABEL: 'iDontKnowDetailsLabel',
    VEHICLE_SECTION_TITLE: 'vehicleSectionTitle',
    VEHICLE_SECTION_DESC: 'vehicleSectionDescLabel',
    VIN_REGISTRATION_LABEL: 'vinregistrationLabel',
    VIN_REGISTRATION_PLACEHOLDER: 'vinRegistrationPlaceholder',
    MILEAGE_LABEL: 'mileageLabel',
    MILEAGE_PLACEHOLDER: 'mileagePlaceholder',
    MILEAGE_RANGE_OPTION: 'mileageRangeOption',
    VIN_REGISTRATION_DATA_PATTERN: 'vinregistrationDataPattern',
    VIN_REGISTRATION_VALIDATION_MESSAGE: 'vinregistrationValidationMessage',
    INVALID_VIN_ERROR_MESSAGE: 'invalidVinErrorMessage',
    INVALID_REGISTRATION_ERROR_MESSAGE: 'invalidRegistrationErrorMessage',
    MILEAGE_VALIDATION_MESSAGE: 'mileageValidationMessage',
    VEHICLE_NOT_FOUND_MESSAGE: 'vehicleNotFoundMessage',
    VEHICLE_SERVICE_ERROR_MESSAGE: 'vehicleServiceErrorMessage',
    ACTIVE_BOOKING: 'activeBookingContent',
    MODAL_FIND_YOUR_VIN_TITLE: 'modalFindYourVinTitle',
    MODAL_FIND_YOUR_VIN_PLACEHOLDER: 'findYourVinPlaceholder',
    MODAL_FIND_YOUR_VIN_SUBTITLE: 'modalFindYourVinSubtitle',
    MODAL_DRIVER_SIDE_DOORFRAME_DESCRIPTION:
        'modalDriversSideDoorframeDescription',
    MODAL_YOUR_VEHICLE_DOCUMENTATION_DESCRIPTION:
        'modalYourVehicleDocumentationDescription',
    MODAL_VISIBLE_THROUGH_WINDSHIELD_DESCRIPTION:
        'modalVisibleThroughWindshieldDescription',
    MODAL_FIND_YOUR_REGISTRATION_NUMBER_LABEL:
        'modalFindYourRegistrationNumberLabel',
    FIND_YOUR_REGISTRATION_PLACEHOLDER: 'findYourRegistrationPlaceholder',
    MODAL_REGISTRATION_NUMBER_DESCRIPTION: 'modalRegistrationNumberDescription',
    RETRIEVE_BOOKING_CTA: 'retrieveBookingButtonLabel',
    RETRIEVE_BOOKING_DESC: 'retrieveBookingDescription',
};

export const OSB_DEFAULT_MODEL_NAME = 'Unknown';
export const EMAIL_REGEX_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const SCHEDULED_SERVICE = '55555';
